"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListHeader = void 0;
var React = require("react");
var recompose_1 = require("recompose");
exports.ListHeader = (0, recompose_1.compose)()(function (_a) {
    var className = _a.className, style = _a.style, projectSchema = _a.projectSchema;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: className + ' row', style: style },
            React.createElement("div", { className: "row__column narrow first" }),
            projectSchema.map(function (cm) {
                if (cm.id === undefined) {
                    return React.createElement("div", null);
                }
                var dataKey = '__' + cm.id;
                return (React.createElement("div", { className: 'row__column name ' + dataKey },
                    React.createElement("div", null, cm.name)));
            }))));
});
